import { initializeApp } from 'firebase/app';
import { getAuth, GithubAuthProvider, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

/**
 * Firebase client (phase B — accounts + sync). The web config is public by
 * design (protected by Firestore Security Rules + authorized domains), so the
 * defaults are safe to ship; env vars allow overriding per environment.
 *
 * This is lazy-friendly: nothing here runs auth/network until a component
 * actually calls `signIn*` or the sync engine subscribes.
 */
// Every field is overridable via VITE_FB_* env (see apps/web/.env.production).
// The literals are the adrule-org project ("markbird-app") and act as the
// baseline; .env.production supplies the same values at build for CI/prod.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY ?? 'AIzaSyDVdNQt8esLMdVNESp-0Tjy7GUBiBzHL-c',
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN ?? 'markbird-app.firebaseapp.com',
  projectId: import.meta.env.VITE_FB_PROJECT_ID ?? 'markbird-app',
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET ?? 'markbird-app.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FB_SENDER_ID ?? '364290199163',
  appId: import.meta.env.VITE_FB_APP_ID ?? '1:364290199163:web:835fa434c4bfe01c82dcde',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();

/**
 * Sign in with Apple. Apple asks for the two scopes explicitly, and hands out a
 * name and email only on the *first* consent — Firebase keeps them from then on,
 * so nothing here has to.
 */
export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');
